import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

export const currentTime = dayjs
  .duration({ hours: dayjs().hour(), minutes: dayjs().minute() })
  .asMinutes()

export const greeting = (i = dayjs()) => {
  const hour = i.hour()
  // console.log('🚀 ~ date.js:11 ~ greeting ~ hour:', hour)

  if (hour >= 4 && hour < 12) {
    return 'בוקר טוב' // (4:00 - 11:59)
  }
  if (hour >= 12 && hour < 15) {
    return 'צהרים טובים' // (12:00 - 15:59)
  }
  if (hour >= 15 && hour < 18) {
    return 'אחר צהריים טובים' // (15:00 - 17:59)
  }
  if (hour >= 18 && hour < 22) {
    return 'ערב טוב' // (16:00 - 21:59)
  }
  return 'לילה טוב'
}

export const formatCurrency = (value) => {
  if (typeof value !== 'number') return '0.00 ₪'
  return `${value.toFixed(2)} ₪`
}
